// outer IIFE to make sure each shared component can define its own isNodeJs.
// isNodeJs is scoped to the outer IIFE this way
(function () {

  // tests available under server/test/generalHelper
  class GeneralHelpers {
    constructor() {

    }

    findById(array, id) {
      return array.find((item) => item._id === id);
    };

    getOrderedArray(array, orderKey = 'order') {
      return array.sort((a, b) => {
        if (typeof a[orderKey] === 'number' && typeof b[orderKey] === 'number') {
          return a[orderKey] - b[orderKey];
        }

        const aLower = String(a[orderKey]).toLowerCase();
        const bLower = String(b[orderKey]).toLowerCase();

        return aLower.localeCompare(bLower);
      });
    }
  }


  exports.GeneralHelpers = new GeneralHelpers();
})();
